export type InstallPlatform = 'desktop' | 'android' | 'apple' | 'unknown';

export function isIOS(): boolean {
  if (typeof navigator === 'undefined') {
    return false;
  }
  return (
    ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
      navigator.platform,
    ) ||
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
}

export function isAndroid(): boolean {
  if (typeof navigator === 'undefined') {
    return false;
  }
  return /android/i.test(navigator.userAgent);
}

export function getSuggestedInstallPlatform(): InstallPlatform {
  if (isIOS()) {
    return 'apple';
  }
  if (isAndroid()) {
    return 'android';
  }
  if (typeof window !== 'undefined' && !isAndroid() && !isIOS()) {
    return 'desktop';
  }
  return 'unknown';
}
